import React from 'react';
import styled from 'styled-components';

const HeaderSidebarBottomItemWrapper = styled.a`
  box-sizing: border-box;
  font-size: 1.8rem;
  padding: 0.5rem 1rem;
  width: fit-content;
  word-wrap: wrap none;
  text-align: left;
  height: 100%;
  cursor: pointer;
  color: var(--color-battleship_grey);
  text-decoration: none;
  #hsbi-title {
    border-bottom: 1.5px solid transparent;
    &:hover {
      border-bottom: 1.5px solid var(--color-battleship_grey);
    }
  }
`;

const HeaderSidebarBottomItem = ({ title, href, target, ...props }) => {
  return (
    <HeaderSidebarBottomItemWrapper
      href={href}
      target={target ? '_blank' : '_self'}
      rel="noopener noreferrer"
      style={props.customStyles}
    >
      <span title={title} id="hsbi-title">
        {title}
      </span>
    </HeaderSidebarBottomItemWrapper>
  );
};

export default HeaderSidebarBottomItem;
